// extracted by mini-css-extract-plugin
module.exports = {"grid":"TwoColumns_grid__4gXLx"};